import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";
import { API_URL, STORAGE_URL } from "../../utils/constants";
import { Col, Row } from "reactstrap";
import BannerDynamicButton from "../../components/Buttons/BannerDynamic";
import { useEffect } from "react";

function BannerPage() {
  const { t } = useTranslation();
  const { state } = useLocation();
  const banner = state?.banner;
  
  const incrementViews = async () => {
    fetch(API_URL+'/banners/'+banner.id+'/increment-views', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  }

  useEffect(() => {
    incrementViews();
  }, []);

  return(
    <MainLayout
      isTopBar
      screenTitle={ t('banner.title') }
    >
      <Row className="justify-content-center mx-0">
        <Col lg="6" md="8" className="px-0">
          <div className="banner-image-container">
            <img 
              src={STORAGE_URL+banner?.image_url} 
              alt={banner?.title} 
              width="100%" 
            />
          </div>

          <div className="banner-description-container py-3 px-2 text-center">
            <p>
              {banner?.description_ar}
            </p>
          </div>

          {(banner?.url_1 || banner?.url_2) && (
            <div className="bottom-fixed-cta">
              {banner?.url_1 && (
                <BannerDynamicButton id={banner?.id} type={banner?.url_1_type} url={banner?.url_1} />
              )}

              {banner?.url_2 && (
                <BannerDynamicButton id={banner?.id} type={banner?.url_2_type} url={banner?.url_2} />
              )}
            </div>
          )}
        </Col>
      </Row>
    </MainLayout>
  );
}

export default BannerPage;